import ScheduleMenu from "@/views/admin/schedule/ScheduleMenu";

export default {
  path: "schedule/menu",
  name: "scheduleMenu",
  component: ScheduleMenu,
  meta: {
    requiresAuth: true
  }
};
